import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * 路由層的 errorElement：任何頁面 render 時 throw，都改顯示這頁，取代 React Router 預設的
 * 「Unexpected Application Error!」。
 *
 * 刻意不放 AppNavbar 等共用元件：錯誤可能就出在那些元件，錯誤頁自己再 throw 就會退回預設錯誤頁。
 * 兩顆按鈕都整頁重新載入，確保殘留的元件狀態被清掉。
 */
function AppErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();

  // 錯誤頁只是讓使用者有出口，錯誤本身仍要印出來，問題才看得到
  useEffect(() => {
    console.error('AppErrorPage: 頁面渲染失敗', error);
  }, [error]);

  return (
    <main className="container-lg">
      <div className="text-center py-5">
        <FontAwesomeIcon icon={["fas", "circle-exclamation"]} className="text-primary mb-4 fs-36" />
        <h3 className="mb-3">{t('app_error_title')}</h3>
        <p className="text-muted mb-4">{t('app_error_description')}</p>
        <div className="d-flex justify-content-center gap-3">
          <button className="btn btn-primaryF rounded-pill" onClick={() => window.location.reload()}>
            <FontAwesomeIcon icon={["fas", "rotate-right"]} className="me-2" />
            {t('retry_load')}
          </button>
          <a href="/" className="btn btn-outline-primaryF rounded-pill">
            <FontAwesomeIcon icon={["fas", "home"]} className="me-2" />
            {t('back_to_home')}
          </a>
        </div>
      </div>
    </main>
  );
}

export default AppErrorPage;
